module.exports = __webpack_public_path__ + "img/Silver Elite.b79d569a.png";